import { sanitize } from 'isomorphic-dompurify';

import { DynamicHeading } from '@gn-audio/jss-components';
import { ProductType } from '@gn-audio/jss-core';

import { StandardPriceModel } from 'api/pricesApi/pricesModel';
import { FamilyGroup } from 'api/productCatalogueApi';
import { Price } from 'composables/Product/Buy/Price/Price';
import { ProductReviews } from 'composables/Product/Buy/ProductReviews';
import useFallbackTranslation from 'utils/hooks/useFallbackTranslation';

export interface ProductInfoProps {
  group?: FamilyGroup;
  uniqueSellingPoint: string;
  price?: StandardPriceModel | null;
  isMainHeading: boolean;
}

export const ProductInfo = ({
  group,
  price,
  uniqueSellingPoint,
  isMainHeading,
}: ProductInfoProps) => {
  const { t } = useFallbackTranslation();
  return (
    <article className="flex flex-col items-start">
      <DynamicHeading isMainHeading={isMainHeading} className="heading-2">
        {group ? (
          <>
            {t('system.Buy')}&nbsp;{group.familyName}
          </>
        ) : (
          <div className="animate-glow text-[transparent]" aria-hidden>
            {t('system.Buy')} Jabra
          </div>
        )}
      </DynamicHeading>

      {uniqueSellingPoint && (
        <div className="paragraph-large" dangerouslySetInnerHTML={{ __html: uniqueSellingPoint }} />
      )}
      <Price productType={ProductType.Product} segmentType={group?.segmentType} price={price} />
      <ProductReviews familyId={group?.familyId} />
      {price?.calloutMsg && (
        <div className="info-msg mt-4">
          <div dangerouslySetInnerHTML={{ __html: sanitize(price?.calloutMsg) }} />
        </div>
      )}
    </article>
  );
};
